/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-08 17:51:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-11-23 16:14:18
 */
import Cookies from 'js-cookie'
export default {
  state: {

    orderQuery: null,
  },
  mutations: {
    'order.query'(state, data) {
      state.orderQuery = data
    },
   
  },
}
